<div class="alerta" *ngIf="mensagem || mensagemBloqueio">
  <span *ngIf="mensagem && tipoPacote === 'S'">
    <strong> {{ mensagem }}</strong>
  </span>

  <span *ngIf="mensagemBloqueio && tipoPacote === 'R'" class="p-p-3">
    <strong> {{ mensagemBloqueio }}</strong>
  </span>

  <a
    id="btn-assinar"
    pButton
    label="Assine Agora"
    data-cy="btn-novo"
    routerLink="/assinatura"
    *ngIf="controlaAssinatura && mensagem && tipoPacote === 'S'"
  ></a>
</div>
